import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CardComponent } from '@app/components/card';
import { LogoComponent } from '@app/components/logo';
import {
  TextColor,
  TextComponent,
  TextSize,
  TextType,
} from '@app/components/text';
import {
  ViewAlign,
  ViewComponent,
  ViewDirection,
  ViewJustify,
} from '@app/components/view';
import { Spacing } from '@app/shared/types';
import { BackgroundPatternComponent } from '../../background-pattern/background-pattern.component';

@Component({
  standalone: true,
  selector: 'app-authentication-layout',
  imports: [
    CommonModule,
    RouterModule,
    BackgroundPatternComponent,
    CardComponent,
    LogoComponent,
    ViewComponent,
    TextComponent,
  ],
  templateUrl: './authentication-layout.component.html',
  styleUrl: './authentication-layout.component.css',
})
export class AuthenticationLayoutComponent {
  TextType = TextType;
  TextSize = TextSize;
  TextColor = TextColor;
  Spacing = Spacing;
  ViewDirection = ViewDirection;
  ViewAlign = ViewAlign;
  ViewJustify = ViewJustify;
}
